export const questionnaireGroupTypes = {
  Maestro: 'Maestro',
  Familia: 'Familia',
};

export const questionnaireTypes = {
  TeacherTherapy: 1,
  FamilyEvaluation: 2,
  FamilyVirtualEvaluation: 3,
  FamilyTherapy: 4,
  FamilyVirtualTherapy: 5,
};

export const parseStateColorByQuestionnaireGroupType = (
  questionnaireGroupType
) => {
  switch (questionnaireGroupType) {
    case questionnaireGroupTypes.Maestro:
      return 'row-background-teacher';
    case questionnaireGroupTypes.Familia:
      return 'row-background-family';
  }
};
